import { AssetReducer } from '../store/asset/reducer';
import { combineReducers } from 'redux';
export var assetRootReducer = combineReducers({
    assets: AssetReducer
});
export default assetRootReducer;
